import { MENU_ITEMS_ADMIN, MenuItemType, MENU_ITEMS_COMERCIAL, MENU_ITEMS_HOLDER, MENU_ITEMS_USERS } from 'appConstants';
import { RolesEnum } from 'types/Roles';

const getMenuItems = (userRole: string | null = null) => {
    // NOTE - You can fetch from server and return here as well
    switch (userRole) {
        case RolesEnum.Admin:
            return MENU_ITEMS_ADMIN;
        case RolesEnum.Comercial:
            return MENU_ITEMS_COMERCIAL;
        case RolesEnum.AccountHolder:
            return MENU_ITEMS_HOLDER;
        case RolesEnum.Users:
            return MENU_ITEMS_USERS;
        default:
            return [];
    }
};


const findAllParent = (menuItems: MenuItemType[], menuItem: MenuItemType): string[] => {
    let parents: string[] = [];
    const parent = findMenuItem(menuItems, menuItem['parentKey']);

    if (parent) {
        parents.push(parent['key']);
        if (parent['parentKey']) parents = [...parents, ...findAllParent(menuItems, parent)];
    }

    return parents;
};

const findMenuItem = (
    menuItems: MenuItemType[] | undefined,
    menuItemKey: MenuItemType['key'] | undefined
): MenuItemType | null => {
    if (menuItems && menuItemKey) {
        for (var i = 0; i < menuItems.length; i++) {
            if (menuItems[i].key === menuItemKey) {
                return menuItems[i];
            }
            var found = findMenuItem(menuItems[i].children, menuItemKey);
            if (found) return found;
        }
    }
    return null;
};

export { getMenuItems, findAllParent, findMenuItem };
